import {MarketerRepository} from '../repository/MarketerRepository';
import {CreateMarketerRequest} from '../models/CreateMarketer';
import {Marketer} from '../models/marketer.model';

export class CreateMarketerUseCase {
  constructor (private marketerRepository: MarketerRepository) {}

  async execute (marketerData: CreateMarketerRequest): Promise<Marketer> {
    // Validate required fields (expecting camelCase from form)
    if (!marketerData.username || marketerData.username.trim() === '') {
      throw new Error('اسم المستخدم مطلوب');
    }

    if (!marketerData.fullName || marketerData.fullName.trim() === '') {
      throw new Error('الاسم الكامل مطلوب');
    }

    if (!marketerData.email || marketerData.email.trim() === '') {
      throw new Error('البريد الإلكتروني مطلوب');
    }

    if (!marketerData.phoneNumber || marketerData.phoneNumber.trim() === '') {
      throw new Error('رقم الهاتف مطلوب');
    }

    if (!marketerData.password || marketerData.password.trim() === '') {
      throw new Error('كلمة المرور مطلوبة');
    }

    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(marketerData.email)) {
      throw new Error('صيغة البريد الإلكتروني غير صحيحة');
    }

    // Validate phone number format (Saudi phone number)
    const phoneRegex = /^(\+966|966|0)?5[0-9]{8}$/;
    if (!phoneRegex.test(marketerData.phoneNumber.replace(/\s+/g, ''))) {
      throw new Error('صيغة رقم الهاتف غير صحيحة (يجب أن يكون رقم سعودي)');
    }

    // Validate password strength
    if (marketerData.password.length < 8) {
      throw new Error('كلمة المرور يجب أن تكون 8 أحرف على الأقل');
    }

    // Set role_id to 2 for marketer and prepare payload for repository
    const marketerPayload: CreateMarketerRequest = {
      ...marketerData,
      role_id: 2, // Marketer role
      phoneNumber: marketerData.phoneNumber.replace(/\s+/g, '') // Remove spaces
    };

    return await this.marketerRepository.create(marketerPayload);
  }
}
